import { createSelector } from '@reduxjs/toolkit';

import type { ReduxStateType } from 'Core/store';
import type { ServerModel } from 'Modules/serverApi/types';

const productSelector = (state: ReduxStateType): ReduxStateType['product'] => state.product;

export const productDataSelector = createSelector(
  productSelector,
  ({ data }): ServerModel.SearchItem | null => data,
);
